<mat-card appearance="outlined" class="card">
  <mat-card-title mat-dialog-title i18n>Select allowed status </mat-card-title>

  <mat-card-content>
    <form [formGroup]="form">
      <mat-form-field>
        <mat-label i18n>select status</mat-label>
        <mat-select formControlName="selectedStatus">
          @for (status of data ; track status) {
          <mat-option [value]="status">{{ status.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </form>
  </mat-card-content>
  <mat-card-actions>
    <div class="flex-row end-center gap-20" mat-dialog-actions>
      <button matButton="outlined" (click)="onCloseClick()" i18n="buttonClose">
        Close
      </button>
      <button
        matButton="elevated"
        color="accent"
        (click)="onSave()"
        [disabled]="!form.valid || !form.touched"
        i18n="@@buttonSave"
      >
        Save
      </button>
    </div>
  </mat-card-actions>
</mat-card>
